import { PlaceholdersId, TFComponent } from '@types';

import { RequestContactPlaceholder } from './requestContact';

export const requestContact: TFComponent = {
	component: RequestContactPlaceholder,
	id: PlaceholdersId.requestContact,
	name: 'requestContact',
};
